<view-file *ngIf="documentSearchParams.identifierId" [parentCategory]="'Agent'" [searchParams]="documentSearchParams"
    [title]="'Documents'" [tabKey]="'documents-tab'">
</view-file>